import { push } from 'connected-react-router';
import { toaster } from 'evergreen-ui';

import Request from '../../../util/Api';
import ErrorHandler from '../../../util/ErrorHandler';
import { setLoading, unsetLoading } from '../../common/Loading/Actions';

// ErrorHandler.parse rethrows anything it doesn't recognize; guard it so an
// unmanaged error still yields a shape we can show + store instead of becoming
// an unhandled rejection (which left create/update failing silently).
const parseError = (e) => {
    try {
        return ErrorHandler.parse(e);
    } catch (unmanaged) {
        return { type: 'unmanaged', message: (e && e.message) || 'Eroare necunoscuta' };
    }
}

// Show the real error text: every validation message (one bullet each) or the
// single error message, as the toast description so all of them reach the user.
const showErrorToast = (parsedErrors, fallbackTitle) => {
    const messages = (parsedErrors.messages && parsedErrors.messages.length)
        ? parsedErrors.messages
        : (parsedErrors.message ? [parsedErrors.message] : []);

    if (messages.length) {
        const description = messages.length > 1 ? messages.map(m => `• ${m}`).join('  ') : messages[0];
        toaster.danger(fallbackTitle || 'Eroare la salvare', { description, duration: 10 });
    } else if (fallbackTitle) {
        toaster.danger(fallbackTitle);
    }
}

export const getAll = (actionGroup, opts, extraFind) => {
    return async (dispatch) => {
        dispatch(setLoading(actionGroup.request.id));
        dispatch(actionGroup.request.thunk());

        try {

            const result = await Request.get(opts.endpoint, null, {
                _start: opts.start,
                _end: opts.start + opts.limit,
                _sort: opts.sort,
                _order: opts.direction,
                q: opts.search,
                extraFilters: JSON.stringify(opts.extraFilters),
                ...extraFind
            });

            const data = result.data.map(item => new opts.mapStructure(item));

            if(opts.successNotification) {
                toaster.success(opts.successNotification);
            }

            dispatch(actionGroup.success.thunk({
                data,
                count: result.count,
                pageSize: opts.limit,
                page: Math.ceil(opts.start / opts.limit) + 1,
                pageCount: Math.ceil(result.count / opts.limit),
                search: opts.search || "",
                sort: opts.sort,
                direction: opts.direction
            }))
        } catch (err) {
            console.log(err);
            dispatch(actionGroup.failure.thunk(err));
            if(opts.errorNotification) {
                toaster.danger(opts.errorNotification);
            }
        }

        dispatch(unsetLoading(actionGroup.request.id));
    }
}

export const getOne = (actionGroup, opts) => {
    return async (dispatch) => {
        dispatch(setLoading(actionGroup.request.id));
        dispatch(actionGroup.request.thunk());

        try {
            const result = await Request.get(opts.endpoint, { id: opts.id });
            const data = new opts.mapStructure(result.data);

            if(opts.successNotification) {
                toaster.success(opts.successNotification);
            }

            dispatch(actionGroup.success.thunk(data));
        } catch (err) {
            console.log(err);
            dispatch(actionGroup.failure.thunk(err));

            if(opts.errorNotification) {
                toaster.danger(opts.errorNotification);
            }
        }

        dispatch(unsetLoading(actionGroup.request.id));
    }
}

export const create = (actionGroup, opts) => {
    return async (dispatch) => {
        dispatch(setLoading(actionGroup.request.id));
        dispatch(actionGroup.request.thunk());

        let crudObject = new opts.mapStructure(opts.values);

        const data = crudObject.export(opts.exportOpts || {})

        for(let i in data) {
            if(data[i] === "" && i === "id") {
                delete data[i];
            }
        }

        try {
            const result = await Request.post(opts.endpoint, null, null, data);
            const createData = new opts.mapStructure(result.data);

            dispatch(actionGroup.success.thunk(createData));

            if(opts.successNotification) {
                toaster.success(opts.successNotification);
            }

            if(opts.nextUrl) {
                dispatch(push(opts.nextUrl + createData.id));
            }
        } catch (e) {
            const parsedErrors = parseError(e);

            showErrorToast(parsedErrors, opts.errorNotification);

            dispatch(actionGroup.failure.thunk(parsedErrors));
        }

        dispatch(unsetLoading(actionGroup.request.id));
    }
}

export const update = (actionGroup, opts) => {
    return async (dispatch) => {
        dispatch(setLoading(actionGroup.request.id));
        dispatch(actionGroup.request.thunk());

        let crudObject = new opts.mapStructure(opts.values);

        const data = crudObject.export()

        try {
            const result = await Request.put(opts.endpoint, { id: opts.id }, null, data);
            const updateData = new opts.mapStructure(result.data);

            dispatch(actionGroup.success.thunk(updateData));

            if(opts.successNotification) {
                toaster.success(opts.successNotification);
            }

            if(opts.nextUrl) {
                dispatch(push(opts.nextUrl + updateData.id));
            }

        } catch (e) {
            const parsedErrors = parseError(e);

            showErrorToast(parsedErrors, opts.errorNotification);

            dispatch(actionGroup.failure.thunk(parsedErrors));
        }

        dispatch(unsetLoading(actionGroup.request.id));
    }
}

export const remove = (actionGroup, opts) => {
    return async (dispatch) => {
        dispatch(setLoading(actionGroup.request.id));
        dispatch(actionGroup.request.thunk());

        try {
            await Request.delete(opts.endpoint, {id: opts.id});

            dispatch(actionGroup.success.thunk());

            if(opts.successNotification) {
                toaster.success(opts.successNotification);
            }

            if(opts.nextUrl) {
                dispatch(push(opts.nextUrl));
            }
        } catch (e) {
            dispatch(actionGroup.failure.thunk(e));

            if(opts.errorNotification) {
                toaster.danger(opts.errorNotification);
            }
        }

        dispatch(unsetLoading(actionGroup.request.id));
    }
}
